export const numberInRange = (value: number, minValue: number, maxValue: number) => {
  return value >= minValue && value <= maxValue;
};

export const generateRandomInt = (min: number, max: number) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const castToNumber = (value: string | number | undefined) => {
  if (typeof value === 'string') {
    return Number(value);
  }
  return value;
};

export const convertFractionToDecimalNumber = (ratio: number | null | undefined, decimalPlaces = 2): number => {
  if (!ratio) {
    return 0;
  }
  return roundNumber(100 * ratio, decimalPlaces);
};

export const mapValueToPercentage = (params: { value: number; min: number; max: number }): number => {
  const { value, min, max } = params;
  return parseFloat(((value - min) / max).toFixed(2)) * 100;
};

export const roundNumber = (value: number, decimalPlaces = 2) => Number(value.toFixed(decimalPlaces));

export const isNonZeroNumber = (value: number | null | undefined): value is number => !!value && value !== Infinity && value !== 0;

export const isDefinedNumber = (value: number | null | undefined): value is number => !!value && !isNaN(value);

export const isNumber = (value?: string | number): boolean => {
  return value != null && value !== '' && !isNaN(Number(value.toString()));
};
